import { useTranslation } from 'react-i18next';

import Button from '@/components/Button';
import Tooltip from '@/components/Tooltip';
import { useTransactionId } from '@/hooks/editor';
import { useLanguage } from '@/hooks/user';

import { oauthClients } from './oauth';

export function OAuthButtons({ type, authTrigger, fastCheckout, ...props }) {
	const { t } = useTranslation();
	const language = useLanguage();
	const id = useTransactionId();

	const buttons = oauthClients
		.map(client => {
			return {
				name: client.name,
				href: client.getUrl({
					type,
					language,
					authTrigger,
					fastCheckout,
					pdfId: id
				}),
				image: client.image,
				provider: client.provider
			};
		})
		.filter(Boolean);

	return (
		<div
			id="buttons"
			className="mb-4 flex justify-center gap-3 md:mb-6 md:gap-4"
			{...props}
		>
			{buttons.map(({ image, name, href }) => {
				return (
					<Tooltip
						key={name}
						title={t(
							type === 'login'
								? 'authModal.login.loginWith'
								: 'authModal.signUp.signUpWith',
							{ provider: name }
						)}
					>
						<Button
							key={name}
							variant="outline"
							className="flex w-full gap-2"
							onClick={() => window.open(href)}
						>
							<img src={image} alt={name} width="24" height="24" />
							<span>
								{t(
									type === 'login'
										? 'authModal.login.loginWith'
										: 'authModal.signUp.signUpWith',
									{ provider: name }
								)}
							</span>
						</Button>
					</Tooltip>
				);
			})}
		</div>
	);
}

export default OAuthButtons;
